export default {
    acordo: {},
    acordos: []
}